<div *ngIf="donationTotals" class="donation-totals">
	<div class="donations-amount-received">
		{{ formatAmount(donationTotals.total) }}
	</div>
	<div class="donations-goal">
		{{ formatAmount(donationTotals.goal) }}
	</div>
	<!-- <stream-donations-progress-component [donationTotals]="donationTotals"></stream-donations-progress-component> -->
</div>
